import React, { Component } from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';
import MassMailForm from '../../forms/MassMail';

import { hideElementForNonAdmins } from '../../utilities/Forms.js'

import Page from '../../components/shared/Page';
import { request, handleRequestErrors } from '../../helpers/Requests'

class MassMailsIndex extends Component {
  constructor(props) {
    super(props);

    this.handleNewPage = this.handleNewPage.bind(this);
    this.handleEditPage = this.handleEditPage.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.updateSentAt = this.updateSentAt.bind(this);
    this.popupCallback = this.popupCallback.bind(this);
  }

  state = {
    mass_mails: [],

    editId: null,
    editSentAt: null,
    newPageToggle: false,
    editPageToggle: false,

    massMailsLoaded: false,
    error: null,
    unauthorized: null
  }

  handleNewPage(event) {
    this.setState({newPageToggle: true});
    this.props.history.push('/mass-mails/new')
  }

  handleEditPage(event) {
    let id = event.currentTarget.id;

    this.setState({editId: id});
    this.setState({editPageToggle: true});
    this.props.history.push(`/mass-mails/${id}`)
  }

  handleBack() {
    this.setState({
      newPageToggle: false,
      editPageToggle: false,
      editId: null,
      editSentAt: null
    });
    this.props.history.push('/mass-mails');
    this.componentDidMount();
  }

  updateSentAt(sent_at) {
    this.setState({
      editSentAt: sent_at
    })
  }

  popupCallback() {
    this.setState({
      popup: Math.random()
    })
  }

  render() {
    const { mass_mails, massMailsLoaded, editId, editSentAt, newPageToggle, editPageToggle, error, unauthorized } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (massMailsLoaded === false) {
      return <p>Loading ...</p>;
    }

    if (newPageToggle) {
      return (
        <Page title="New Mass Mail">
          <MassMailForm key="0" mode="create" handleBack={this.handleBack} />
        </Page>
      )
    }

    if (editPageToggle) {
      return (
        <Page title={`${editSentAt ? "View" : "Edit"} Mass Mail`}>
          <MassMailForm key="1" mode="update" id={editId} handleBack={this.handleBack} updateSentAt={this.updateSentAt} popupCallback={this.popupCallback} />
        </Page>
      )
    }

    return (
      <div>
        <Page title="Mass Mails">
          <h3>List of Mass Mails</h3>


          <Link to={'/mass-mails/new'} onClick={this.handleNewPage}>
            <div className={`button new-button ${hideElementForNonAdmins()}`}>New Mass Mail</div>
          </Link>

          <div className="table big-table">
            <div className="tr heading">
              <div className="th">Subject</div>
              <div className="th">Body</div>
              <div className="th">Type of Person</div>
              <div className="th">Location</div>
              <div className="th">Recipient Count</div>
              <div className="th">Sent At</div>
            </div>
            {mass_mails.map((mass_mail) => (
              <Link to={`/mass-mails/${mass_mail.id}`} onClick={this.handleEditPage} id={mass_mail.id} key={mass_mail.id} className="tr">
                <div className="td">{mass_mail.subject}</div>
                <div className="td">{mass_mail.body}</div>
                <div className="td">{mass_mail.type_of_person}</div>
                <div className="td">{mass_mail.location}</div>
                <div className="td center">{mass_mail.person_count}</div>
                <div className="td">{mass_mail.sent_at}</div>
              </Link>
            ))}
          </div>
        </Page>
      </div>
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (state.newPageToggle && props.match.params.id !== undefined) {
      return {
        newPageToggle: false,
        editPageToggle: true,
        editId: props.match.params.id
      }
    }
    else if (state.editPageToggle && props.match.params.id === undefined) {
      return {
        editPageToggle: false
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith("/mass-mails")) {
      return {
        newPageToggle: false,
        editPageToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/new")) {
      return {
        newPageToggle: true,
        editPageToggle: false,
        editId: null
      }
    }
    else if (props.history.action === "POP" && props.match.params.id !== undefined) {
      return {
        newPageToggle: false,
        editPageToggle: true,
        editId: props.match.params.id
      }
    }
    else {
      return null
    }
  }

  componentDidMount() {
    request("GET", `/v1/a/user_mass_mails`, "", () => {this.setState({unauthorized: true})})
      .then(data => {this.setState({ mass_mails: data, massMailsLoaded: true })})
      .catch(error => handleRequestErrors(this, error, { massMailsLoaded: true }))
  }
}

export default withRouter(MassMailsIndex);
